import React from 'react'
import { Progress } from 'reactstrap'
import {
  formatBudgetMoney,
  getEsteiraPctBarAppearance,
  pctRelativoReferencia,
} from './budgetDashboardHelpers'

const labelStyle = {
  fontSize: '0.65rem',
  color: '#74788d',
  letterSpacing: '0.02em',
}

export function BudgetEsteiraBar({
  etapaLabel,
  valor = 0,
  referencia = 0,
  pct,
  className = 'mb-2',
}) {
  const v = Number(valor || 0)
  const r = Number(referencia || 0)
  const semReferencia = !(r > 0)
  const pctNum = pct ?? pctRelativoReferencia(r, v)
  const acimaDoTeto = r > 0 && v > r
  const barValue = semReferencia ? 0 : Math.min(Number(pctNum) || 0, 100)
  const appearance = getEsteiraPctBarAppearance(pctNum, acimaDoTeto)
  const pctLabel = semReferencia
    ? (v > 0 ? '—' : '0%')
    : (pctNum == null ? '—' : `${pctNum}%`)

  return (
    <div className={className}>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span style={{ ...labelStyle, textTransform: 'uppercase' }}>
          {etapaLabel}
        </span>
        <span
          className="small font-weight-bold"
          style={{ color: appearance.pctColor }}
        >
          {pctLabel}
        </span>
      </div>
      {!semReferencia && (
        <Progress value={barValue} color={appearance.progressColor} style={{ height: 6 }} />
      )}
      <div
        className="small text-muted mt-1"
        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {formatBudgetMoney(v)}
        {' / '}
        {r > 0 ? formatBudgetMoney(r) : '—'}
      </div>
    </div>
  )
}
